export enum AutoDraft {
  None = 0,
  Save = 2,
  Restore = 4,
}
